// Module
var code = "<div class=\"outer-box\">\r\n  <div class=\"date-label\" data-bind=\"text: label\"></div>\r\n  <div>\r\n    <div class=\"time-text\" data-bind=\"text: local() && local().time\"></div>\r\n    <div class=\"date-text\" data-bind=\"text: local() && local().date\"></div>\r\n  </div>\r\n</div>\r\n";
// Exports
module.exports = code;